import { api } from '../api';

export const getBlob = async (url: string) => {
  const response = await api.get<Blob>(url, { responseType: 'blob' });
  return new Blob([response.data]);
};
